import { render, staticRenderFns } from "./manage.vue?vue&type=template&id=565566de&scoped=true&"
import script from "./manage.vue?vue&type=script&lang=js&"
export * from "./manage.vue?vue&type=script&lang=js&"
import style0 from "./manage.vue?vue&type=style&index=0&id=565566de&prod&lang=less&scoped=true&"
import style1 from "./manage.vue?vue&type=style&index=1&id=565566de&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565566de",
  null
  
)

export default component.exports